import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import i18n from '../../../language/i18n'
import { normalizeLang } from '../../../utils/localeDataLoader'
import { getBasePathByKeyName } from '../../../utils/navMenuCache'
import { getProductSolutionGroups } from '../../../apis/productSolutionGroups'

function PScategory() {
    const navigate = useNavigate();
    const [productMenu, setProductMenu] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const fetchGroups = async () => {
            setLoading(true);
            try {
                const currentLang = normalizeLang(i18n.language);
                const data = await getProductSolutionGroups(currentLang);
                if (!cancelled) {
                    setProductMenu(data);
                }
            } catch (error) {
                console.error('[PScategory] Lỗi khi tải nhóm sản phẩm:', error);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        fetchGroups();
        return () => { cancelled = true; };
    }, [i18n.language]);

    if (loading) {
        return (
            <div className='PScategory'>
                <div className="container" style={{ textAlign: 'center', padding: '40px 0' }}>
                    <p>Đang tải...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='PScategory'>
            <div className="container">
                <div className="row">
                    {productMenu.map((value, index) =>
                        <div key={value.id} className='col-xs-12 col-md-3 col-lg-4'>
                            <div className='PScategory-list'>
                                <div className="PScategory-itemlist" style={{ "--ps-delay": `${index * 80}ms` }}>
                                    <div
                                        className="item-img"
                                        onClick={() => navigate(`/${getBasePathByKeyName('menu.products', normalizeLang(i18n.language)) || 'san-pham-giai-phap'}/${value.slug}`)}
                                    >
                                        <img src={value.image} alt={value.name} />
                                    </div>
                                    <h4>{value.name}</h4>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PScategory
